/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import fetchWorkspaceId from './fetchWorkspaceId.tsx';

export const RESOURCE_TYPE_SERVICEDESK_WORKSPACE_CONTEXT = 'JSM_INSIGHT_WORKSPACE_CONTEXT';

export const workspaceResource: RouteResource<string | null> = createResource<WorkspaceId | null>({
	type: RESOURCE_TYPE_SERVICEDESK_WORKSPACE_CONTEXT,
	getKey: () => 'state',
	getData: async (_, routerContext) => {
		const workspaceId = await fetchWorkspaceId(_, routerContext);
		return workspaceId;
	},
	maxAge: Infinity,
});
